export default __webpack_public_path__ + "static/media/pcbFab.c7df470d.svg";